import { type ReactNode } from 'react';
import styled from '@emotion/styled';
import Text from 'components/common/typography/text';

interface PopoverTreeLabelProps {
  icon: ReactNode;
  text: string;
  onClick?: (e: React.MouseEvent) => void;
  'data-e2e'?: string;
}

const PopoverTreeLabel = ({ icon, text, onClick, 'data-e2e': dataE2e }: PopoverTreeLabelProps) => {
  return (
    <LabelContent onClick={onClick} data-e2e={dataE2e}>
      {icon}
      <LabelName variant="labelMd" color="heading" ellipsis>
        {text}
      </LabelName>
    </LabelContent>
  );
};

const LabelName = styled(Text)`
  padding: 0 var(--padding-xxxs);
  max-width: 200px;
  cursor: pointer;
  margin-top: 1px;
`;

const LabelContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  /* The wrapping Button owns the box. Declaring one here too painted a second, smaller box inside it
     with its own hover. Only the internal rhythm belongs here: Figma's 2px between siblings. */
  gap: var(--spacing-xxxxs);
`;

export default PopoverTreeLabel;
